<div class="silsile">
  <div class="silsile-ust">
    <div class="silsile-bilgi">
      <ng-container *ngIf="!yukleniyor && !hata && belgeSayisi > 1">
        Silsilede {{ belgeSayisi }} belge
        <span *ngIf="merkezDegisti" class="silsile-not">· başka bir belgeye odaklanıldı</span>
      </ng-container>
      <span *ngIf="kesildi" class="silsile-uyari">Silsile çok büyük; ilk 200 belge / 10 seviye gösteriliyor.</span>
    </div>
    <div class="silsile-dugmeler">
      <dx-button
        *ngIf="merkezDegisti"
        text="Seçili belgeye dön"
        icon="revert"
        stylingMode="outlined"
        type="default"
        (onClick)="seciliBelgeyeDon()"
      ></dx-button>
      <dx-button hint="Yenile" icon="refresh" stylingMode="text" (onClick)="yenile()"></dx-button>
    </div>
  </div>

  <div *ngIf="hata" class="silsile-bos">{{ hata }}</div>
  <div *ngIf="iliskiYok" class="silsile-bos">Bu belgenin ilişkili (ilgi tutulan ya da cevap olarak yazılan) başka belgesi yok.</div>

  <dx-tree-list
    *ngIf="!hata && !iliskiYok"
    class="silsile-agac"
    [dataSource]="satirlar"
    keyExpr="id"
    parentIdExpr="ustId"
    [rootValue]="0"
    [autoExpandAll]="true"
    [(expandedRowKeys)]="acikAnahtarlar"
    [showBorders]="true"
    [showRowLines]="true"
    [columnAutoWidth]="false"
    [wordWrapEnabled]="true"
    [allowColumnResizing]="true"
    [height]="'100%'"
    noDataText=""
    (onRowPrepared)="onRowPrepared($event)"
    (onRowDblClick)="onRowDblClick($event)"
  >
    <dxo-sorting mode="none"></dxo-sorting>
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxi-column dataField="konu" caption="Konu" [minWidth]="160"></dxi-column>
    <dxi-column dataField="tarih" caption="Tarih" [width]="90"></dxi-column>
    <dxi-column dataField="sayi" caption="Sayı" [width]="130"></dxi-column>
    <dxi-column dataField="birim" caption="Birim / Kurum" [width]="170"></dxi-column>
    <dxi-column dataField="yon" caption="Yön" [width]="60"></dxi-column>
    <dxi-column caption="İlişki" [calculateCellValue]="iliskiMetni" [width]="115"></dxi-column>
    <dxi-column dataField="durum" caption="Durum" [width]="100"></dxi-column>
    <dxi-column dataField="gizlilik" caption="Gizlilik" [width]="100" [visible]="false"></dxi-column>
    <dxi-column dataField="kayitNo" caption="Kayıt No" [width]="85" [visible]="false"></dxi-column>
    <dxi-column type="buttons" [width]="70">
      <dxi-button hint="Üst yazıyı görüntüle" icon="eyeopen" [visible]="ustYaziGorunur" [onClick]="ustYaziTikla"></dxi-button>
      <dxi-button hint="Silsileyi bu belgeden kur" icon="hierarchy" [visible]="odaklanGorunur" [onClick]="odaklanTikla"></dxi-button>
    </dxi-column>
    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
  </dx-tree-list>

  <dx-load-panel [visible]="yukleniyor" [showPane]="true" [shading]="false" [position]="{ of: '.silsile' }"></dx-load-panel>
</div>

<dk-form-popup
  *ngIf="ustYaziVisible"
  [formMetada]="formMetaData"
  [state]="'View'"
  [popupName]="'BysBelge'"
  [visible]="ustYaziVisible"
  (visibleChange)="ustYaziVisible = $event"
  [height]="'70vh'"
  [width]="'70vw'"
  [title]="'Belge Görüntüle'"
>
  <!-- DKM-5139 Cedric: eski hâli -->
  <!-- <dk-ust-yazi-popup [belgeKod]="ustYaziBelgeKod"></dk-ust-yazi-popup> -->
  <dk-ust-yazi-popup [belgeKod]="ustYaziBelgeKod" [onIzleme]="ustYaziOnIzleme"></dk-ust-yazi-popup>
</dk-form-popup>
